import { AxiosResponse } from 'axios';
import { PackagedProductGetDTO } from 'svila-common';
import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  // get: async (id) => {
  //   return request(`${API_URL}/products/generics/${id}`, 'get', {}, {});
  // },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/packaged-products/${id}`, 'put', body);
  },
  // create: async (values) => {
  //   const body = JSON.stringify(values);
  //   return request(`${API_URL}/products/generics/`, 'post', body, {});
  // },
  delete: async (id) => {
    return request(`${API_URL}/products/packaged-products/${id}`, 'delete');
  },
  create: async (productId: string, packageId: string): Promise<AxiosResponse<PackagedProductGetDTO[]>> => {
    return request(`${API_URL}/products/packaged-products/${productId}/${packageId}`, 'post');
  },
};
